import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { APIClient } from "../../helpers/api_helper";

const apiClient = new APIClient();

export const getUsers = createAsyncThunk("users/getUsers", async () => {
  try {
    const response = await apiClient.get("/users");
    return response;
  } catch (error) {
    toast.error(error.message || "Failed to fetch users", { autoClose: 3000 });
    throw error;
  }
});

export const getUserById = createAsyncThunk("users/getUserById", async (id) => {
  try {
    const response = await apiClient.get(`/users/${id}`);
    return response;
  } catch (error) {
    toast.error(error.message || "Failed to fetch user", { autoClose: 3000 });
    throw error;
  }
});

export const addNewUser = createAsyncThunk("users/addNewUser", async (userData) => {
  try {
    const response = await apiClient.create("/users", userData);
    toast.success("User Added Successfully", { autoClose: 3000 });
    return response;
  } catch (error) {
    toast.error(error.message || "Failed to add user", { autoClose: 3000 });
    throw error;
  }
});

export const updateUser = createAsyncThunk("users/updateUser", async ({ id, userData }) => {
  try {
    const response = await apiClient.put(`/users/${id}`, userData);
    toast.success("User Updated Successfully", { autoClose: 3000 });
    return response;
  } catch (error) {
    toast.error(error.message || "Failed to update user", { autoClose: 3000 });
    throw error;
  }
});

export const deleteUser = createAsyncThunk("users/deleteUser", async (id) => {
  try {
    await apiClient.delete(`/users/${id}`);
    toast.success("User Deleted Successfully", { autoClose: 3000 });
    return { id };
  } catch (error) {
    toast.error(error.message || "Failed to delete user", { autoClose: 3000 });
    throw error;
  }
});

export const getRoles = createAsyncThunk("users/getRoles", async () => {
  try {
    const response = await apiClient.get("/roles");
    return response;
  } catch (error) {
    // If roles endpoint doesn't exist, return empty array
    console.warn("Roles endpoint not available:", error.message);
    return [];
  }
});
